module.exports = __webpack_public_path__ + "img/case-tab-bg-01.053f6da8.jpg";